export const EXAM_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  facingMode: 'user',
  width: { ideal: 1280 },
  height: { ideal: 720 },
  frameRate: { ideal: 30, max: 30 },
};

/**
 * Fallback sem `max` no frameRate para webcams que recusam o limite estrito
 * via OverconstrainedError. Mantém os ideais para indicar preferência.
 */
export const EXAM_VIDEO_CONSTRAINTS_RELAXED: MediaTrackConstraints = {
  facingMode: 'user',
  width: { ideal: 1280 },
  height: { ideal: 720 },
  frameRate: { ideal: 30 },
};

export const EXAM_AUDIO_CONSTRAINTS: MediaTrackConstraints = {
  sampleRate: 44100,
  channelCount: 1,
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};

const EXAM_MEDIA_RECORDER_BITRATES = {
  videoBitsPerSecond: 2_000_000,
  audioBitsPerSecond: 128_000,
} as const;

const PREFERRED_MIME_TYPES = [
  'video/webm;codecs=vp9,opus',
  'video/webm;codecs=vp8,opus',
  'video/webm',
  'video/mp4',
] as const;

export function resolvePreferredMimeType(): string | undefined {
  if (typeof MediaRecorder === 'undefined') return undefined;
  const { isTypeSupported } = MediaRecorder;
  if (typeof isTypeSupported !== 'function') return undefined;
  return PREFERRED_MIME_TYPES.find(mime =>
    isTypeSupported.call(MediaRecorder, mime),
  );
}

export function buildExamMediaRecorderOptions(): MediaRecorderOptions {
  const mimeType = resolvePreferredMimeType();
  return {
    ...EXAM_MEDIA_RECORDER_BITRATES,
    ...(mimeType ? { mimeType } : {}),
  };
}

export function resolveUploadFilename(blob: Blob): string {
  const type = blob.type || '';
  if (type.includes('webm')) return 'video.webm';
  if (type.includes('mp4')) return 'video.mp4';
  return 'video.mp4';
}
